/**
 * App.js
 */
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'
export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_SHOW_UPLOAD_FILE_MODAL = 'SET_SHOW_UPLOAD_FILE_MODAL'
export const SET_FILE_QUERY = 'SET_FILE_QUERY'
export const SET_IS_LOADING_FILE_LIST = 'SET_IS_LOADING_FILE_LIST'
export const SET_FILE_LIST_INFO = 'SET_FILE_LIST_INFO'

/**
 * User.js
 */
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USERINFO = 'SET_USERINFO'
export const LOGOUT = 'LOGOUT'
